import React from 'react'
import { Grid, Box, Divider, FormControlLabel, Checkbox } from '@mui/material'
import { StyledButton } from '@/shared/ui/buttons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSync } from '@fortawesome/pro-duotone-svg-icons'
import ArchivedMessage from './ArchivedMessage'
import DeletedMessage from './DeletedMessage'
import DefaultSearchbar from '@/shared/composed-ui/search/DefaultSearchbar'
import { MessagesHeaderProps } from './types'

const MessagesHeader: React.FC<MessagesHeaderProps> = ({
    filter,
    checked,
    checkall,
    items,
    showAdditionalContent,
    kedo,
    getButton,
    getCheckedItems,
    closeChangeReadStatus,
    selectAll,
    fetchItems,
    handleFilterChange,
    onSearch,
    search,
    onReset,
}) => {
    return (
        <>
            <Grid container sx={{ justifyContent: 'space-between' }}>
                <Grid>
                    {filter === 'incoming' && (
                        <Box sx={{ mb: { xs: 0, md: 2 } }}>
                            <Box sx={{ display: 'inline-flex' }}>
                                <StyledButton sx={{ p: 0, mr: 1 }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={
                                                    checked.length ===
                                                    items.length
                                                }
                                                onChange={selectAll}
                                            />
                                        }
                                        label={kedo.t('Select all')}
                                        sx={{ m: 0, mr: 2 }}
                                    />
                                </StyledButton>

                                <Divider
                                    orientation="vertical"
                                    sx={{
                                        display: 'inline-block',
                                        borderColor: 'grey.300',
                                        height: 40,
                                        mx: 0.625,
                                    }}
                                />

                                <StyledButton
                                    sx={{
                                        maxHeight: 'fit-content',
                                        display: 'inline-block',
                                    }}
                                    onClick={() => fetchItems({ filter })}
                                >
                                    <FontAwesomeIcon icon={faSync} />
                                </StyledButton>
                            </Box>

                            <Box
                                gap="16px"
                                sx={{
                                    display: 'flex',
                                    alignItems: 'flex-end',
                                    mt: 1,
                                    maxWidth: '100%',
                                }}
                            >
                                {(checkall || checked.length > 0) &&
                                    getButton()}

                                {(checkall || checked.length > 0) && (
                                    <Box sx={{ mt: 1 }}>
                                        <ArchivedMessage
                                            kedo={kedo}
                                            getCheckedItems={getCheckedItems}
                                            updateMessage={
                                                closeChangeReadStatus
                                            }
                                        />
                                    </Box>
                                )}

                                {(checkall || checked.length > 0) && (
                                    <Box sx={{ mt: 1 }}>
                                        <DeletedMessage
                                            kedo={kedo}
                                            getCheckedItems={getCheckedItems}
                                            updateMessage={
                                                closeChangeReadStatus
                                            }
                                        />
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    )}
                </Grid>

                {!showAdditionalContent && (
                    <Grid size={{ xs: 8, md: 6 }} sx={{ mb: 1 }}>
                        <Box
                            sx={{
                                display: { xs: 'block', md: 'none' },
                                height: '1rem',
                            }}
                        />
                        <DefaultSearchbar
                            kedo={kedo}
                            handleChange={handleFilterChange}
                            onSearch={onSearch}
                            searchName={search}
                            onReset={onReset}
                        />
                    </Grid>
                )}
            </Grid>

            {showAdditionalContent && (
                <Grid container>
                    <Grid size={12} sx={{ mx: 0.5, mb: 1 }}>
                        <DefaultSearchbar
                            kedo={kedo}
                            handleChange={handleFilterChange}
                            onSearch={onSearch}
                            searchName={search}
                            onReset={onReset}
                        />
                    </Grid>
                </Grid>
            )}
        </>
    )
}

export default MessagesHeader
